import Vue from 'vue';
import accountService from '@/modules/account-service';

const ADD_PAYMENT_REQUEST = 'ADD_PAYMENT_REQUEST',
	ADD_PAYMENT_SUCCESS = 'ADD_PAYMENT_SUCCESS',
	ADD_PAYMENT_ERROR = 'ADD_PAYMENT_ERROR',
	RESET_PAYMENT_STATUS = 'RESET_PAYMENT_STATUS',
	GET_RECEIPTS_REQUEST = "GET_RECEIPTS_REQUEST",
	GET_RECEIPTS_SUCCESS = "GET_RECEIPTS_SUCCESS",
	GET_RECEIPTS_ERROR = "GET_RECEIPTS_ERROR";

const state = {
	status: {},
	receipts: []
};

const getters = {
	paymentMethods: state => state.paymentMethods,
	paymentStatus: state => state.status,
	receipts: state => state.receipts
};

const actions = {
	[ADD_PAYMENT_REQUEST]: ({ commit, dispatch }, payload) => {
		return new Promise((resolve, reject) => {
			commit(ADD_PAYMENT_REQUEST);
			accountService.addPaymentMethod(payload)
				.then(response => {
					commit(ADD_PAYMENT_SUCCESS, response);
					dispatch('UPDATE_PAYMENT_METHOD', response, {root: true});
					resolve();
				})
				.catch(error => {
					commit(ADD_PAYMENT_ERROR);
					reject(error);
				});
		});
	},
	[GET_RECEIPTS_REQUEST]: ({ commit, dispatch }, payload) => {
		commit(GET_RECEIPTS_REQUEST);

		accountService.getReceipts()
			.then(response => {
				commit(GET_RECEIPTS_SUCCESS, response);
			})
			.catch(error => {
				commit(GET_RECEIPTS_ERROR);
			});
	},
	[RESET_PAYMENT_STATUS]: ({ commit, dispatch}) => {
		commit(RESET_PAYMENT_STATUS);
	},

};

const mutations = {
	[ADD_PAYMENT_REQUEST]: (state) => {
		state.status = {
			loading: true
		};
	},
	[ADD_PAYMENT_SUCCESS]: (state, response) => {
		state.status = {
			success: {
				method: true
			}
		};
	},
	[ADD_PAYMENT_ERROR]: (state) => {
		state.status = {
			error: {
				method: true
			}
		};
	},
	[GET_RECEIPTS_REQUEST]: (state) => {
		state.status = {
			loading: true
		};
	},
	[GET_RECEIPTS_SUCCESS]: (state, response) => {
		state.status = {
			success: {
				receipts: true
			}
		};
		state.receipts = response;
	},
	[GET_RECEIPTS_ERROR]: (state) => {
		state.status = {
			error: {
				receipts: true
			}
		};
	},
	[RESET_PAYMENT_STATUS]: (state) => {
		state.status = {};
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/payment.js